// @flow

import type { Action } from './store.type';

export const VERIFY_DISCOUNT_CODE_REQUEST = 'VERIFY_DISCOUNT_CODE_REQUEST';
type VERIFY_DISCOUNT_CODE_REQUEST_TYPE = 'VERIFY_DISCOUNT_CODE_REQUEST';

export const VERIFY_DISCOUNT_CODE_SUCCESS = 'VERIFY_DISCOUNT_CODE_SUCCESS';
type VERIFY_DISCOUNT_CODE_SUCCESS_TYPE = 'VERIFY_DISCOUNT_CODE_SUCCESS';

export const VERIFY_DISCOUNT_CODE_FAILURE = 'VERIFY_DISCOUNT_CODE_FAILURE';
type VERIFY_DISCOUNT_CODE_FAILURE_TYPE = 'VERIFY_DISCOUNT_CODE_FAILURE';

export const SUBSCRIBE_PLAN_REQUEST = 'SUBSCRIBE_PLAN_REQUEST';
type SUBSCRIBE_PLAN_REQUEST_TYPE = 'SUBSCRIBE_PLAN_REQUEST';

export const SUBSCRIBE_PLAN_SUCCESS = 'SUBSCRIBE_PLAN_SUCCESS';
type SUBSCRIBE_PLAN_SUCCESS_TYPE = 'SUBSCRIBE_PLAN_SUCCESS';

export const SUBSCRIBE_PLAN_FAILURE = 'SUBSCRIBE_PLAN_FAILURE';
type SUBSCRIBE_PLAN_FAILURE_TYPE = 'SUBSCRIBE_PLAN_FAILURE';

export const ACTIVATE_CHARGE_REQUEST = 'ACTIVATE_CHARGE_REQUEST';
type ACTIVATE_CHARGE_REQUEST_TYPE = 'ACTIVATE_CHARGE_REQUEST';

export const ACTIVATE_CHARGE_SUCCESS = 'ACTIVATE_CHARGE_SUCCESS';
type ACTIVATE_CHARGE_SUCCESS_TYPE = 'ACTIVATE_CHARGE_SUCCESS';

export const ACTIVATE_CHARGE_FAILURE = 'ACTIVATE_CHARGE_FAILURE';
type ACTIVATE_CHARGE_FAILURE_TYPE = 'ACTIVATE_CHARGE_FAILURE';

export const CLEAR_DISCOUNT_CODE = 'CLEAR_DISCOUNT_CODE';
type CLEAR_DISCOUNT_CODE_TYPE = 'CLEAR_DISCOUNT_CODE';

export const SUBSCRIBE_ADDON_REQUEST = 'SUBSCRIBE_ADDON_REQUEST';
type SUBSCRIBE_ADDON_REQUEST_TYPE = 'SUBSCRIBE_ADDON_REQUEST';

export const SUBSCRIBE_ADDON_SUCCESS = 'SUBSCRIBE_ADDON_SUCCESS';
type SUBSCRIBE_ADDON_SUCCESS_TYPE = 'SUBSCRIBE_ADDON_SUCCESS';

export const SUBSCRIBE_ADDON_FAILURE = 'SUBSCRIBE_ADDON_FAILURE';
type SUBSCRIBE_ADDON_FAILURE_TYPE = 'SUBSCRIBE_ADDON_FAILURE';

export const UNSUBSCRIBE_ADDON_REQUEST = 'UNSUBSCRIBE_ADDON_REQUEST';
type UNSUBSCRIBE_ADDON_REQUEST_TYPE = 'UNSUBSCRIBE_ADDON_REQUEST';

export const UNSUBSCRIBE_ADDON_SUCCESS = 'UNSUBSCRIBE_ADDON_SUCCESS';
type UNSUBSCRIBE_ADDON_SUCCESS_TYPE = 'UNSUBSCRIBE_ADDON_SUCCESS';

export const UNSUBSCRIBE_ADDON_FAILURE = 'UNSUBSCRIBE_ADDON_FAILURE';
type UNSUBSCRIBE_ADDON_FAILURE_TYPE = 'UNSUBSCRIBE_ADDON_FAILURE';

export const GET_ADDONS_REQUEST = 'GET_ADDONS_REQUEST';
type GET_ADDONS_REQUEST_TYPE = 'GET_ADDONS_REQUEST';

export const GET_ADDONS_SUCCESS = 'GET_ADDONS_SUCCESS';
type GET_ADDONS_SUCCESS_TYPE = 'GET_ADDONS_SUCCESS';

export const GET_ADDONS_FAILURE = 'GET_ADDONS_FAILURE';
type GET_ADDONS_FAILURE_TYPE = 'GET_ADDONS_FAILURE';

export const GET_ADDON_STATUS_REQUEST = 'GET_ADDON_STATUS_REQUEST';
type GET_ADDON_STATUS_REQUEST_TYPE = 'GET_ADDON_STATUS_REQUEST';

export const GET_ADDON_STATUS_SUCCESS = 'GET_ADDON_STATUS_SUCCESS';
type GET_ADDON_STATUS_SUCCESS_TYPE = 'GET_ADDON_STATUS_SUCCESS';

export const GET_ADDON_STATUS_FAILURE = 'GET_ADDON_STATUS_FAILURE';
type GET_ADDON_STATUS_FAILURE_TYPE = 'GET_ADDON_STATUS_FAILURE';

export const GET_PACKAGE_PLANS_REQUEST = 'GET_PACKAGE_PLANS_REQUEST';
type GET_PACKAGE_PLANS_REQUEST_TYPE = 'GET_PACKAGE_PLANS_REQUEST';

export const GET_PACKAGE_PLANS_SUCCESS = 'GET_PACKAGE_PLANS_SUCCESS';
type GET_PACKAGE_PLANS_SUCCESS_TYPE = 'GET_PACKAGE_PLANS_SUCCESS';

export const GET_PACKAGE_PLANS_FAILURE = 'GET_PACKAGE_PLANS_FAILURE';
type GET_PACKAGE_PLANS_FAILURE_TYPE = 'GET_PACKAGE_PLANS_FAILURE';

export const GET_INVOICE_PLANS_REQUEST = 'GET_INVOICE_PLANS_REQUEST';
type GET_INVOICE_PLANS_REQUEST_TYPE = 'GET_INVOICE_PLANS_REQUEST';

export const GET_INVOICE_PLANS_SUCCESS = 'GET_INVOICE_PLANS_SUCCESS';
type GET_INVOICE_PLANS_SUCCESS_TYPE = 'GET_INVOICE_PLANS_SUCCESS';

export const GET_INVOICE_PLANS_FAILURE = 'GET_INVOICE_PLANS_FAILURE';
type GET_INVOICE_PLANS_FAILURE_TYPE = 'GET_INVOICE_PLANS_FAILURE';

export const SKIP_SUBSCRIBE_REQUEST = 'SKIP_SUBSCRIBE_REQUEST';
type SKIP_SUBSCRIBE_REQUEST_TYPE = 'SKIP_SUBSCRIBE_REQUEST';

export const SKIP_SUBSCRIBE_SUCCESS = 'SKIP_SUBSCRIBE_SUCCESS';
type SKIP_SUBSCRIBE_SUCCESS_TYPE = 'SKIP_SUBSCRIBE_SUCCESS';

export const SKIP_SUBSCRIBE_FAILURE = 'SKIP_SUBSCRIBE_FAILURE';
type SKIP_SUBSCRIBE_FAILURE_TYPE = 'SKIP_SUBSCRIBE_FAILURE';

type SubscriptionSuccess = {
  data: Object
};

type SubscriptionFailure = {
  error: any
};

// Verify discount code
type VerifyDiscountCodeRequestAction = Action<VERIFY_DISCOUNT_CODE_REQUEST_TYPE, null>;

type VerifyDiscountCodeSuccessAction = Action<
  VERIFY_DISCOUNT_CODE_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type VerifyDiscountCodeFailureAction = Action<
  VERIFY_DISCOUNT_CODE_FAILURE_TYPE,
  SubscriptionFailure
>;

// Subscribe plan
type SubscribePlanRequestAction = Action<SUBSCRIBE_PLAN_REQUEST_TYPE, null>;

type SubscribePlanSuccessAction = Action<SUBSCRIBE_PLAN_SUCCESS_TYPE, SubscriptionSuccess>;

type SubscribePlanFailureAction = Action<SUBSCRIBE_PLAN_FAILURE_TYPE, SubscriptionFailure>;

// Active charge
type ActivateChargeRequestAction = Action<ACTIVATE_CHARGE_REQUEST_TYPE, null>;

type ActivateChargeSuccessAction = Action<ACTIVATE_CHARGE_SUCCESS_TYPE, SubscriptionSuccess>;

type ActivateChargeFailureAction = Action<ACTIVATE_CHARGE_FAILURE_TYPE, SubscriptionFailure>;

type ClearDiscountCodeAction = Action<CLEAR_DISCOUNT_CODE_TYPE, null>;

// Skip subscribe
type SkipSubscribeRequestAction = Action<SKIP_SUBSCRIBE_REQUEST_TYPE, null>;

type SkipSubscribeSuccessAction = Action<SKIP_SUBSCRIBE_SUCCESS_TYPE, unknown>;

type SkipSubscribeFailureAction = Action<SKIP_SUBSCRIBE_FAILURE_TYPE, null>;

// Addon
type SubscribeAddonRequestAction = Action<SUBSCRIBE_ADDON_REQUEST_TYPE, null>;

type SubscribeAddonSuccessAction = Action<SUBSCRIBE_ADDON_SUCCESS_TYPE, SubscriptionSuccess>;

type SubscribeAddonFailureAction = Action<SUBSCRIBE_ADDON_FAILURE_TYPE, SubscriptionFailure>;

type UnsubscribeAddonRequestAction = Action<UNSUBSCRIBE_ADDON_REQUEST_TYPE, null>;

type UnsubscribeAddonSuccessAction = Action<UNSUBSCRIBE_ADDON_SUCCESS_TYPE, SubscriptionSuccess>;

type UnsubscribeAddonFailureAction = Action<UNSUBSCRIBE_ADDON_FAILURE_TYPE, SubscriptionFailure>;

type GetAddonsRequestAction = Action<GET_ADDONS_REQUEST_TYPE, null>;

type GetAddonsSuccessAction = Action<GET_ADDONS_SUCCESS_TYPE, SubscriptionSuccess>;

type GetAddonsFailureAction = Action<GET_ADDONS_FAILURE_TYPE, SubscriptionFailure>;

type GetAddonStatusRequestAction = Action<GET_ADDON_STATUS_REQUEST_TYPE, null>;

type GetAddonStatusSuccessAction = Action<GET_ADDON_STATUS_SUCCESS_TYPE, SubscriptionSuccess>;

type GetAddonStatusFailureAction = Action<GET_ADDON_STATUS_FAILURE_TYPE, SubscriptionFailure>;

type GetPackagePlansRequestAction = Action<GET_PACKAGE_PLANS_REQUEST_TYPE, null>;

type GetPackagePlansSuccessAction = Action<GET_PACKAGE_PLANS_SUCCESS_TYPE, SubscriptionSuccess>;

type GetPackagePlansFailureAction = Action<GET_PACKAGE_PLANS_FAILURE_TYPE, SubscriptionFailure>;

type GetInvoicePlansRequestAction = Action<GET_INVOICE_PLANS_REQUEST_TYPE, null>;

type GetInvoicePlansSuccessAction = Action<GET_INVOICE_PLANS_SUCCESS_TYPE, SubscriptionSuccess>;

type GetInvoicePlansFailureAction = Action<GET_INVOICE_PLANS_FAILURE_TYPE, SubscriptionFailure>;

export type SubscriptionAction =
  | VerifyDiscountCodeRequestAction
  | VerifyDiscountCodeSuccessAction
  | VerifyDiscountCodeFailureAction
  | SubscribePlanRequestAction
  | SubscribePlanSuccessAction
  | SubscribePlanFailureAction
  | ActivateChargeRequestAction
  | ActivateChargeSuccessAction
  | ActivateChargeFailureAction
  | ClearDiscountCodeAction
  | SubscribeAddonRequestAction
  | SubscribeAddonSuccessAction
  | SubscribeAddonFailureAction
  | UnsubscribeAddonRequestAction
  | UnsubscribeAddonSuccessAction
  | UnsubscribeAddonFailureAction
  | GetAddonsRequestAction
  | GetAddonsSuccessAction
  | GetAddonsFailureAction
  | GetAddonStatusRequestAction
  | GetAddonStatusSuccessAction
  | GetAddonStatusFailureAction
  | GetPackagePlansRequestAction
  | GetPackagePlansSuccessAction
  | GetPackagePlansFailureAction
  | GetInvoicePlansRequestAction
  | GetInvoicePlansSuccessAction
  | GetInvoicePlansFailureAction
  | SkipSubscribeRequestAction
  | SkipSubscribeSuccessAction
  | SkipSubscribeFailureAction;

export type SubsciptionState = {
  verifying: boolean,
  subscribing: boolean,
  activating: boolean,
  subscribeSuccess: boolean,
  success: boolean,
  error: any,
  discountValue: 0,
  discountType: string,
  confirmationUrl: string,
  migrateESCluster: boolean
};
